var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13036_63302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.27529 10.3158C11.9601 10.3158 14.1443 8.11412 14.1443 5.40792C14.1443 2.70172 11.9601 0.5 9.27529 0.5C6.59051 0.5 4.40625 2.70169 4.40625 5.40789C4.40625 8.11409 6.59051 10.3158 9.27529 10.3158ZM10.6305 7.40714C10.2929 7.40714 10.0429 7.13118 10.0283 6.80487C10.0137 6.47959 10.3155 6.2026 10.6305 6.2026C10.9682 6.2026 11.2182 6.47856 11.2328 6.80487C11.2474 7.13014 10.9456 7.40714 10.6305 7.40714ZM10.4852 2.50359C10.7238 2.60372 10.836 2.87827 10.7359 3.11685L8.68305 8.00831C8.60778 8.18764 8.43391 8.29561 8.25087 8.29561C8.19043 8.29561 8.12903 8.28383 8.06979 8.25897C7.83121 8.15884 7.719 7.88429 7.81912 7.64571L9.87196 2.75425C9.97212 2.51567 10.2467 2.40349 10.4852 2.50359ZM7.8581 4.66505C7.52046 4.66505 7.27045 4.38909 7.25583 4.06278C7.24128 3.73751 7.54307 3.46052 7.8581 3.46052C8.19574 3.46052 8.44578 3.73648 8.4604 4.06278C8.47492 4.38803 8.17313 4.66505 7.8581 4.66505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77496 11.8906H0.706752C0.448031 11.8906 0.238281 12.1004 0.238281 12.3591V16.0316C0.238281 16.2903 0.448031 16.5001 0.706752 16.5001H1.77496V11.8906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.622 11.8568C14.7439 10.9788 13.3152 10.9787 12.4372 11.8568L11.0338 13.2602L10.4586 13.8353C10.2262 14.0678 9.91087 14.1984 9.58209 14.1984H6.78526C6.53266 14.1984 6.31529 14.0043 6.30339 13.752C6.29071 13.4826 6.50536 13.2602 6.77199 13.2602H9.61486C10.1865 13.2602 10.6822 12.8532 10.7805 12.2901C10.8031 12.1608 10.8148 12.0279 10.8148 11.8922C10.8149 11.634 10.6039 11.4227 10.3457 11.4227H8.78797C8.27887 11.4227 7.79001 11.1918 7.27244 10.9473C6.72954 10.6908 6.16819 10.4256 5.5118 10.382C4.93774 10.3437 4.3623 10.4066 3.80148 10.5685C3.20099 10.7419 2.76934 11.2754 2.717 11.8913C2.715 11.8912 2.71297 11.8912 2.71094 11.891V16.4974C2.71116 16.4974 2.71137 16.4974 2.71159 16.4974V16.4996H10.782C11.3369 16.4996 11.8586 16.2835 12.2511 15.8911L15.6219 12.5203C15.8052 12.3371 15.8052 12.04 15.622 11.8568Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13036_63302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money_icon.b022ff7cafe995a327cf9003ff71085c.svg";
export { ForwardRef as ReactComponent };